import { useQuery } from 'react-query';
import { tenantService, type Tenant } from '@/services/tenantService';
import { getActiveTenantId } from '@/store/tenantSelection';

export function useTenants() {
  return useQuery<Tenant[]>({
    queryKey: ['tenants'],
    queryFn: async () => (await tenantService.listTenants()).filter((tenant) => tenant.status === 'active'),
    staleTime: 5 * 60 * 1000,
  });
}

export function useTenant(selectedTenantId?: string) {
  const tenantId = selectedTenantId ?? getActiveTenantId();
  return useQuery<Tenant>({
    queryKey: ['tenant', tenantId],
    queryFn: () => tenantService.getTenantById(tenantId),
    staleTime: 5 * 60 * 1000,
  });
}
